import styled from "styled-components/macro";
import { HouseDoor, Check, X, Heart, HeartFill } from "@styled-icons/bootstrap";

export const Container = styled.div`
  padding: 1rem;
  background: ${(props) => props.theme.colors.place};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 4px;
  position: relative;
  max-width: 350px;
  display:flex;
  flex-direction:column;
  word-break: break-word;

  .layout {
    position: absolute;
    width: 100%;
    height: 75%;
    top: 0;
    left: 0;
    background: rgba(255, 252, 246, 0.6);
  }

  .zindex {
    z-index: 1;
    position: relative;
  }

  .image {
    width: 100%;
    padding: 0 0 70% 0;
    margin-bottom: 1rem;
    position: relative;
    overflow: hidden;
    border: 1px solir ${(props) => props.theme.colors.border};

    .label {
      position: absolute;
      top: 0.5rem;
      left: 0.5rem;
      padding: 0.25rem 0.5rem;
      background: rgba(250, 252, 255, 0.75);
      border-radius: 4px;
      color: ${(props) => props.theme.colors.text};
      line-height: 130%;
      font-size: 1rem;
      cursor: pointer;
      &:hover {
        & > label {
          display: block;
        }
      }
      & > label {
        position: absolute;
        bottom: calc(100% + 4px);
        right: -40px;
        display: none;
        width: 340px;
        transition: 0.7s;
        font-size: 14px;
      }
    }

    img {
      border-radius: 4px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
    }
  }

  .dates {
    font-size: 12px;
    line-height: 150%;
    color: ${(props) => props.theme.colors.textMuted};
    margin-bottom: 0.5rem;
  }

  .city {
    color: ${(props) => props.theme.colors.text};
    font-size: 14px;
    line-height: 130%;
    margin-bottom: 0.5rem;
  }

  .info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;

    .price {
      color: ${(props) => props.theme.colors.primary};
      font-size: 18px;
      line-height: 133%;
    }

    .size {
      color: ${(props) => props.theme.colors.textDimmed};
      font-size: 14px;
      line-height: 133%;

      .number {
        color: ${(props) => props.theme.colors.text};
        font-size: 18px;
      }
    }

    .option {
      color: ${(props) => props.theme.colors.text};
      font-size: 14px;
      line-height: 130%;
      margin-left: 5px;
    }
  }

  a {
    text-decoration: none;
  }

  .aboutLink {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${(props) => props.theme.colors.border};
    border-radius: 6px;
    color: ${(props) => props.theme.colors.textDimmed};
    font-size: 14px;
    line-height: 130%;
    position: relative;
    z-index: 1;

    & > div {
      position: relative;
      z-index: 1;
    }
  }
`;

// align-content: center;
//     flex-direction: column;
//     flex-wrap: wrap;
//     justify-content: center;
//     align-items: stretch;
//     height: auto;
//     width: 100%;

export const DivButtons = styled.div`
  display: flex;
  align-content: center;
  flex-direction: column;
  ustify-content: center;
  margin: auto 0;
  // margin-top: 1em;  
  position: relative;
  z-index: 1;
  flex-direction: column;
  & > button {
     width: 100%;
     height: 36px;
     padding: 0;
    margin: 0.2rem 0 0.2rem 0;
  }
`;

export const HouseDoorIcon = styled(HouseDoor)`
  width: 15px;
  margin-right: 5px;
  color: ${(props) => props.theme.colors.textDimmed};
`;

export const CheckIcon = styled(Check)`
  width: 30px;
  color: ${(props) => props.theme.colors.thirdly};
`;

const HeartIconFill = styled(HeartFill)`
  width: 25px;
  color: ${(props) => props.theme.colors.thirdly};
`;

export const HeartIcon = styled(Heart)`
  width: 25px;
  color: ${(props) => props.theme.colors.thirdly};
  &:hover {
    // width: 30px;
    // border: 2px solid;
    // ${HeartIconFill}
    
  }
`;

export const DeclineIcon = styled(X)`
  width: 30px;
  color: ${(props) => props.theme.colors.thirdly};
`;

/* .buttons {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1;

    button {
      width: 45%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${(props) => props.theme.colors.secondary};
      height: 36px;
      border: none;
      border-radius: 4px;
      cursor: pointer;

      &.removeButton {
        width: 100%;
        background: ${(props) => props.theme.colors.place};
        color: ${(props) => props.theme.colors.thirdly};
        font-size: 1rem;
        line-height: 130%;
        border: 1px solid ${(props) => props.theme.colors.border};
      }
    }
  } */
